module.exports = __webpack_public_path__ + "/static/images/osu_logo.e0fb1c5fa8be0f5f59706ed37f5c2195.png";


//////////////////
// WEBPACK FOOTER
// ./images/osu_logo.png
// module id = uTt8
// module chunks = 0